import { useEffect, useState } from 'react';
import ReactFinalForm from 'components/form/ReactFinalForm';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';
import { required } from 'helpers/validators';
import { IAccessor, IOption } from 'interfaces';
import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';
import { AutocompleteAdapter } from 'components/form/AutocompleteAdapter';
import { equipmentService } from 'services/api';

interface AccessorFormParams {
  accessor: IAccessor;
  onSubmit: any;
  isDisabledEdit?: boolean;
}
function AccessorForm(params: AccessorFormParams) {
  const { t } = useTranslation();

  const [equipments, setEquipments] = useState<IOption[]>([]);

  useEffect(() => {
    equipmentService.getAllBaseInformation().then((res) => {
      setEquipments(
        res.map((eq) => {
          return {
            id: +eq['id'],
            code: `${eq['description']} (SN ${eq['serial_number']}) - (ID. ${eq['internal_id']})`
          };
        })
      );
    });
  }, []);

  const { accessor, onSubmit, isDisabledEdit } = params;
  return (
    <div>
      {accessor && (
        <ReactFinalForm onSubmit={onSubmit} edit={!!accessor.id}>
          <div className="flex flex-wrap">
            <div className="w-full md:w-1/2 p-2">
              <IdentityField
                name="code"
                initialValue={accessor.code}
                component={TextFieldAdapter}
                label={t('global.code')}
                type="text"
                validate={required}
                disabled={isDisabledEdit}
                required
              />
            </div>

            <div className="w-full md:w-1/2 p-2">
              <IdentityField
                name="description"
                initialValue={accessor.description}
                component={TextFieldAdapter}
                label={t('global.description')}
                type="text"
                validate={required}
                disabled={isDisabledEdit}
                required
              />
            </div>

            <div className="w-full md:w-1/2 p-2">
              <IdentityField
                name="serial_number"
                initialValue={accessor.serial_number}
                component={TextFieldAdapter}
                label={t('global.serial_number')}
                type="text"
                validate={required}
                disabled={isDisabledEdit}
                required
              />
            </div>

            {!accessor.id && (
              <>
                <div className="w-full md:w-1/2 p-2">
                  <IdentityField
                    name="equipment"
                    component={AutocompleteAdapter}
                    options={equipments}
                    placeholder={t('global.equipment')}
                    type="text"
                    required
                  />
                </div>
              </>
            )}
            {/* 
            {accessor.id && accessor.equipment && (
              <div className="w-full md:w-1/2 p-2">
                <IdentityField
                  name="contract_equipment"
                  component={TextFieldAdapter}
                  initialValue={`${ticket['equipment_description']} (SN ${ticket['serial_number']}) - (ID. ${ticket['internal_id']})`}
                  options={equipments}
                  placeholder={t('global.equipment')}
                  type="text"
                  disabled={true}
                />
              </div>
            )} */}
          </div>
        </ReactFinalForm>
      )}
    </div>
  );
}

export default AccessorForm;
